module.exports = __webpack_public_path__ + "static/media/ic_step_grey.28b96d15.svg";